import React, {useEffect } from 'react'; 
import Header from "../Component/Header";
import { Link } from 'react-router-dom'
const SchoolTiming = () => {
    useEffect(() => {
        document.title = 'SchoolTiming -  The Air Force School Subroto Park';  
    }, []);  
  return (
     <>
       <Header/>
<div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li> The Almanac  </li>
                 <li>School Rules</li>
                 <li>SchoolTiming</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1> SchoolTiming </h1>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12"> 
                    <div className="table-responsive maintable">
                    <table className="table">
                       <tbody>
                       <tr><td>Junior School : </td> <td>7.50 a.m. To 1.40 p.m. </td> </tr> 
                       <tr><td>Senior School : </td> <td>7.50 a.m. To 1.50 p.m. </td> </tr>
                       <tr><td>Office / Administrative Hours : </td> <td>8.00 a.m. To 3.00 p.m. </td>  </tr>
                       <tr><td>Syndicate Bank Extension Counter : </td> <td>Mon - Fri : 09.00 - 13.00 Hrs. <br/> Saturday : 09.00 Hrs. - 13.00 Hrs. <br/> Weekly Off : 2nd & 4th Saturday, Sunday </td>  </tr>
                       <tr><td>Visitnig Hours For Parents : </td> <td>Visiting hours : 02.00 p.m. To 02.30 p.m. </td>  </tr>
                       <tr><td>Principal / Headmistress : </td> <td>On all the working days i.e. Monday to Friday or with an appointment.  </td> </tr>
                       </tbody>
                    </table>
                    </div>
                    </div>
                </div>
            </div>
        </div>
     </>
  )
}

export default SchoolTiming